import { supabase } from "../supabase";
import { DESIGN_FILES_BUCKET } from "./designFiles";

const PUBLIC_BUCKET = "designs";

// Pulls a path back out of a public Storage URL
// (".../storage/v1/object/public/<bucket>/<path>") — null for anything that
// isn't actually a public URL in that bucket (an off-site link, or a private path).
export function storagePathFromPublicUrl(url, bucket) {
  if (!url) return null;
  const marker = `/storage/v1/object/public/${bucket}/`;
  const at = url.indexOf(marker);
  if (at === -1) return null;
  return decodeURIComponent(url.slice(at + marker.length));
}

// Every Storage path one design's own files live at — its photos and its design
// files, whichever bucket each is actually in. Older posts kept an ordinary public
// link for their design files; newer ones have a private-bucket `path` instead
// (see utils/designFiles.js) — either way, the path this design owns comes back here.
export function designStoragePaths(design) {
  const publicPaths = new Set();
  const privatePaths = new Set();

  [design.image_url, ...(design.images || []), design.design_url].forEach(url => {
    const path = storagePathFromPublicUrl(url, PUBLIC_BUCKET);
    if (path) publicPaths.add(path);
  });

  (design.design_files || []).forEach(f => {
    if (f.path) privatePaths.add(f.path);
    else {
      const path = storagePathFromPublicUrl(f.url, PUBLIC_BUCKET);
      if (path) publicPaths.add(path);
    }
  });

  return { publicPaths: [...publicPaths], privatePaths: [...privatePaths] };
}

export async function removeStoragePaths(bucket, paths) {
  const CHUNK_SIZE = 100;
  for (let i = 0; i < paths.length; i += CHUNK_SIZE) {
    const chunk = paths.slice(i, i + CHUNK_SIZE);
    const { error } = await supabase.storage.from(bucket).remove(chunk);
    if (error) {
      console.log(`STORAGE CLEANUP (${bucket}) ERROR:`, error);
    }
  }
}

// Removes one design's own files from Storage. Best-effort and meant to run right
// after its database row is already deleted — a Storage hiccup here just leaves an
// orphaned file behind rather than blocking the delete the person actually asked for.
export async function removeDesignStorage(design) {
  const { publicPaths, privatePaths } = designStoragePaths(design);
  if (publicPaths.length > 0) await removeStoragePaths(PUBLIC_BUCKET, publicPaths);
  if (privatePaths.length > 0) await removeStoragePaths(DESIGN_FILES_BUCKET, privatePaths);
}
